import React, { useEffect, useState } from 'react';
import { Button, Layout, Menu, Modal, Progress, Steps, Tag } from 'antd';
import classNames from 'classnames';
import { motion } from 'framer-motion';
import $ from 'jquery';
import { isMobile } from 'react-device-detect';
import { BsFillChatRightTextFill } from 'react-icons/bs';
import { FaRegEdit, FaUser } from 'react-icons/fa';
import { GoCheckCircleFill } from 'react-icons/go';
import { MdOutlineTipsAndUpdates } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import useSound from 'use-sound';

import { CreditCardModal } from '../../../components/CreditCard/CreditCardModal';
import { RoadmapModal } from '../../../components/Roadmap/RoadmapModal';
import UpgradeModal from '../../../components/UpgradeModal';
import AnalysisModal from '../../pages/Home/Partials/AnalysisModal';
import AnalysisReadyModal from '../../pages/Home/Partials/AnalysisReadyModal';
// import LimitModal from '../../pages/Home/Partials/LimitModal';
import WelcomeAnalysisModal from '../../pages/Home/Partials/WelcomeAnalysisModal';
import WelcomebackModal from '../../pages/Home/Partials/WelcomebackModal';
import { MenuOutlined } from '@ant-design/icons';
import SafeModal from './SafeModal';
import StepModal from './StepModal';
import UserMenu from './UserMenu';
import WordModal from './WordModal';
import boopSfx from '../../../assets/sounds/effect1.mp3';
import { useSocket } from '../../../context/socket';
import { getStorage } from '../../../helpers';
import { setSiderCollapsed } from '../../../redux/app/appSlice';
import { getUser } from '../../../redux/auth/authSlice';
import {
  getMessages,
  setGenerating,
  setHasMore,
  setMessages,
  setPage,
  setTotalMessages,
  updateMessage,
} from '../../../redux/message/messageSlice';
import {
  getThreads,
  setOpenPayModal,
  setOpenWordModal,
  setSelectedThread,
  setShowExpiredModal,
  setShowUpgradeModal,
} from '../../../redux/thread/threadSlice';

import { clickBullet, newThread } from '../../../services/threadAPI';
import { setReadAnalysis } from '../../../services/userAPI';

import './SideBar.scss';

const { Sider } = Layout;

export const titles = {
  personality: 'Personality Analysis',
  behaviorPattern: 'Thought Pattern',
  cognitiveDistortion: 'Blind-Spot Analysis',
  unmetNeedsMapping: 'Personalized Roadmap',
};

const analysisStepTitles = ["Let's Dive Deeper", "I'll Guide You", "Let's Explore"];

const contentVariants = {
  initial: {
    opacity: 0,
    y: 10,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.2,
      delay: 0.1,
    },
  },
  exit: {
    opacity: 0,
    y: -10,
    transition: {
      duration: 0.2,
    },
  },
};

function SideBar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const socket = useSocket();

  const { id } = useParams();

  const siderCollapsed = useSelector((state) => state.app.siderCollapsed);
  const user = useSelector((state) => state.auth.user);
  const isPayed = useSelector(
    (state) =>
      state.auth.user.activeSubscription &&
      (state.auth.user.activeSubscription.status === 'active' ||
        state.auth.user.activeSubscription.status === 'trialing'),
  );
  const selectedThread = useSelector((state) => state.thread.selectedThread);
  const threads = useSelector((state) => state.thread.threads);
  const thread = useSelector((state) =>
    state.thread.threads.find((_thread) => _thread._id === state.thread.selectedThread),
  );
  const showExpiredModal = useSelector((state) => state.thread.showExpiredModal);
  const showUpgradeModal = useSelector((state) => state.thread.showUpgradeModal);
  const openWordModal = useSelector((state) => state.thread.openWordModal);
  const messages = useSelector((state) => state.message.messages);
  const page = useSelector((state) => state.message.page);
  const limit = useSelector((state) => state.message.limit);
  const hasMore = useSelector((state) => state.message.hasMore);
  const loading = useSelector((state) => state.message.loading);
  const total = useSelector((state) => state.message.total);
  const totalMessages = useSelector((state) => state.message.totalMessages);
  const generating = useSelector((state) => state.message.generating);
  const step = useSelector((state) => parseInt(state.message.total / 5));
  const selectedPlan = useSelector((state) => state.thread.selectedPlan);
  const openPayModal = useSelector((state) => state.thread.openPayModal);
  const [current, setCurrent] = useState('');
  const [openTour, setOpenTour] = useState(false);
  const [showAnalyzeModal, setShowAnalyzeModal] = useState(false);
  const [showWelcomebackModal, setShowWelcomebackModal] = useState(false);
  const [showSafeModal, setShowSafeModal] = useState(false);
  const [showWelcomeAnalysisModal, setShowWelcomeAnalysisModal] = useState(false);
  const [selectedTab, setSelectedTab] = useState('positive');
  const [analysisData, setAnalysisData] = useState(null);
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState('chats');
  const [showAnalysisReadyModal, setShowAnalysisReadyModal] = useState(false);
  const [readyKey, setReadyKey] = useState('');

  const [openKey /* , setOpenKey */] = useState('advice');

  const [effectSound] = useSound(boopSfx);

  const [showPersonalityModal, setShowPersonalityModal] = useState(false);

  const toolsItems = [
    {
      key: 'personality',
      label: (
        <div className="flex items-center gap-2 justify-between">
          <div className="leading-4">
            <span className="font-semibold text-[16px]">Personality Analysis</span>
            {!user.analysis?.personality?.content && (
              <p className="text-xs text-gray-400 m-0">(Unlock at 25 messages)</p>
            )}
          </div>
          {user.analysis?.personality?.isNew && (
            <Tag color="#f00" className="rounded-full animate-pulse">
              <span className="text-xs text-white">New</span>
            </Tag>
          )}
        </div>
      ),
      icon: <FaUser />,
      disabled: !user.analysis?.personality?.content,
    },
    {
      key: 'behaviorPattern',
      label: (
        <div className="flex items-center gap-2 justify-between">
          <div className="leading-4">
            <span className="font-semibold text-[16px]">Thought Pattern</span>
            {!user.analysis?.behaviorPattern?.content && (
              <p className="text-xs text-gray-400 m-0">(Unlock at 50 messages)</p>
            )}
          </div>
          {user.analysis?.behaviorPattern?.isNew && (
            <Tag color="#f00" className="rounded-full animate-pulse">
              <span className="text-xs text-white">New</span>
            </Tag>
          )}
        </div>
      ),
      icon: <MdOutlineTipsAndUpdates />,
      disabled: !user.analysis?.behaviorPattern?.content,
    },
    {
      key: 'cognitiveDistortion',
      label: (
        <div className="flex items-center gap-2 justify-between">
          <div className="leading-4">
            <span className="font-semibold text-[16px]">Blind-Spot Analysis</span>
            {!user.analysis?.cognitiveDistortion?.content && (
              <p className="text-xs text-gray-400 m-0">(Unlock at 100 messages)</p>
            )}
          </div>
          {user.analysis?.cognitiveDistortion?.isNew && (
            <Tag color="#f00" className="rounded-full animate-pulse">
              <span className="text-xs text-white">New</span>
            </Tag>
          )}
        </div>
      ),
      icon: <MdOutlineTipsAndUpdates />,
      disabled: !user.analysis?.cognitiveDistortion?.content,
    },
    {
      key: 'unmetNeedsMapping',
      label: (
        <div className="flex items-center gap-2 justify-between">
          <div className="leading-4">
            <span className="font-semibold text-[16px]">Personalized Roadmap</span>
            {!user.analysis?.unmetNeedsMapping?.content && (
              <p className="text-xs text-gray-400 m-0">(Unlock at 200 messages)</p>
            )}
          </div>
          {user.analysis?.unmetNeedsMapping?.isNew && (
            <Tag color="#f00" className="rounded-full animate-pulse">
              <span className="text-xs text-white">New</span>
            </Tag>
          )}
        </div>
      ),
      icon: <MdOutlineTipsAndUpdates />,
      disabled: !user.analysis?.unmetNeedsMapping?.content,
    },
  ];

  const onToolsClick = (e) => {
    if (thread.status === 1) {
      return dispatch(setShowExpiredModal(true));
    }
    if (thread.back === 1) {
      return;
    }
    setCurrent(e.key);

    if (isMobile) {
      dispatch(setSiderCollapsed(true));
    }

    setShowPersonalityModal(true);
    if (user.analysis[e.key]?.isNew) {
      setReadAnalysis({ type: e.key });
      dispatch(getUser());
    }
  };

  const handleNewChat = () => {
    newThread()
      .then((res) => {
        dispatch(setPage(1));
        dispatch(setHasMore(true));
        dispatch(setMessages([]));
        dispatch(getThreads());
        navigate(location.pathname.replace(selectedThread, res.data.thread._id));
        dispatch(setSelectedThread(res.data.thread._id));
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    setShowSafeModal(!!getStorage('registered'));
    dispatch(getThreads());
  }, [dispatch]);

  useEffect(() => {
    if (socket && current) {
      socket.on('_analysisMessage', (data) => {
        console.log('_analysisMessage', data);
        setCurrent('');
      });
    }
    if (socket) {
      socket.on('analysisMessage', () => {
        dispatch(setGenerating(true));
      });
    }
    return () => {
      if (socket) {
        socket.off('_analysisMessage');
        socket.off('analysisMessage');
      }
    };
  }, [socket, current, dispatch]);

  useEffect(() => {
    if (id && id !== selectedThread) {
      dispatch(setSelectedThread(id));
    } else if (!id && selectedThread) {
      if (location.pathname.includes('playground')) {
        navigate(selectedThread);
      }
    }
  }, [id, selectedThread, dispatch, navigate, location]);

  useEffect(() => {
    dispatch(getUser());
  }, [dispatch, tab]);

  useEffect(() => {
    dispatch(setTotalMessages(user.totalMessages));
  }, [dispatch, user.totalMessages]);

  useEffect(() => {
    if (threads.length > 0) {
      setItems(
        threads.map((thread) => {
          if (thread.subTitles?.length > 0) {
            return {
              key: thread._id,
              label: <p className="m-0 max-w-full font-bold text-[16px] truncate">{thread.title || 'New chat'}</p>,
              icon: <BsFillChatRightTextFill />,
              children: thread.analysisSteps
                .slice(0, 3)
                .map((step, index) => ({
                  ...step,
                  index: index,
                }))
                .filter((step) => step.step < 3)
                .map((step, index) => ({
                  key: thread._id + index,
                  label: (
                    <div className="leading-5">
                      <p className="m-0 font-bold text-[14px]">{analysisStepTitles[step.index]}</p>
                      <motion.p
                        className="m-0 text-gray-600 whitespace-pre-line"
                        variants={contentVariants}
                        initial="initial"
                        animate="animate"
                        exit="exit"
                        key={step.bullets[step.step]}
                      >
                        {step.bullets[step.step]}
                      </motion.p>
                    </div>
                  ),
                  onClick: async () => {
                    if (generating) return;
                    if (thread.status === 1) return dispatch(setShowExpiredModal(true));
                    dispatch(setGenerating(true));
                    clickBullet(selectedThread, { index: step.index }).then(() => {
                      dispatch(getThreads());
                      dispatch(
                        updateMessage({
                          role: 'user',
                          content: `Can we explore "${step.bullets[step.step]}" for my current situation.`,
                          _id: Date.now() + 'user',
                        }),
                      );
                      socket.emit('sendMessage', {
                        prompt: `Can we explore "${step.bullets[step.step]}" for my current situation.`,
                        stream: true,
                        threadId: thread._id,
                        text: true,
                        auto: true,
                      });
                    });
                  },
                })),
            };
          }
          return {
            key: thread._id,
            label: <p className="m-0 font-bold text-[16px]">{thread.title || 'New chat'}</p>,
            icon: <BsFillChatRightTextFill />,
            children: [
              {
                key: thread._id + '0',
                className: 'stepper-view-menu',
                label: (
                  <>
                    <Steps
                      direction="vertical"
                      size="small"
                      current={step}
                      className={classNames(
                        'h-full min-h-72 analysis-steps',
                        `step-${step + 1} percent-${(total % 5) * 20}`,
                      )}
                      items={[
                        {
                          title: (
                            <span className="font-bold" /* ref={ref1} */>
                              Listening ({step === 0 ? parseInt(total % 5) : 5}/5)
                            </span>
                          ),
                        },
                        {
                          title: (
                            <span className="font-bold" /* ref={ref2} */>
                              Analyzing ({step === 1 ? parseInt(total % 5) : step > 1 ? 5 : 0}/5)
                            </span>
                          ),
                        },
                        {
                          title: (
                            <span className="font-bold" /* ref={ref3} */>
                              Roadmap {/* ({step == 2 ? (total % 20) : (step > 2 ? 10 : 0)}/10) */}
                            </span>
                          ),
                        },
                      ]}
                    />
                  </>
                ),
              },
            ],
          };
        }),
      );
      if (!selectedThread) {
        dispatch(setSelectedThread(threads[0]._id));
      }
    }
  }, [threads, selectedThread, total, step, messages, dispatch, generating]);

  useEffect(() => {
    if (socket) {
      socket.on('answer', (data) => {
        if (data.end) {
          dispatch(setGenerating(false));
        } else {
          if (selectedThread === data.threadId) {
            dispatch(
              updateMessage({
                role: 'assistant',
                content: data.content,
                _id: data._id,
              }),
            );
          }
        }
      });

      socket.on('limitReached', () => {
        dispatch(getThreads());
        if (isPayed) {
          console.log('---limitReached----');
          dispatch(setShowExpiredModal(true));
        }
      });

      socket.on('analysis', (data) => {
        dispatch(getUser());
        setReadyKey(data.type);
        setShowAnalysisReadyModal(true);
      });
    }
    return () => {
      if (socket) {
        socket.off('answer');
        socket.off('limitReached');
        socket.off('analysis');
      }
    };
  }, [socket, messages, isPayed, dispatch, selectedThread]);

  useEffect(() => {
    if (socket) {
      socket.on('analysisData', (data) => {
        effectSound();
        setAnalysisData(data);
        setShowAnalyzeModal(true);
      });
      socket.on('analyzed_thread', () => {
        effectSound();
        dispatch(getThreads());
      });
      socket.on('SUBSCRIPTION_EVENT', (data) => {
        console.log('SUBSCRIPTION_EVENT', data);
        dispatch(getUser());
        dispatch(getThreads());
        dispatch(setMessages([]));
        dispatch(setPage(1));
        dispatch(setHasMore(true));
      });
    }

    return () => {
      if (socket) {
        socket.off('SUBSCRIPTION_EVENT');
        socket.off('analysisData');
        socket.off('analyzed_thread');
      }
    };
  }, [socket, effectSound, dispatch]);

  useEffect(() => {
    if (id === thread?._id) {
      if (thread && thread.back === 1 && !isPayed) {
        setShowWelcomebackModal(true);
      } else if (thread && thread.status === 1 && !isPayed) {
        dispatch(setShowExpiredModal(true));
      } else if (thread && isPayed) {
        setShowWelcomebackModal(false);
      }
    }
  }, [threads, isPayed, dispatch, id]);

  useEffect(() => {
    if (!loading && selectedThread && hasMore) {
      console.log('loading...');
      dispatch(getMessages({ threadId: selectedThread, query: { page, limit }, nickName: user.nickName }));
    }
  }, [selectedThread, page, user]);

  return (
    <Sider
      style={{
        overflow: 'auto',
        height: '100%',
        position: 'fixed',
        insetInlineStart: 0,
        top: 0,
        bottom: 0,
        scrollbarWidth: 'thin',
        scrollbarColor: 'unset',
        zIndex: 999,
      }}
      breakpoint="md"
      onBreakpoint={(broken) => {
        if (broken) {
          dispatch(setSiderCollapsed(true));
        } else {
          dispatch(setSiderCollapsed(false));
        }
      }}
      className={classNames(!isPayed && '', 'sidebar !bg-transparent')}
      collapsedWidth={0}
      width={isMobile ? '100%' : 310}
      collapsed={siderCollapsed}
      collapsible
      trigger={null}
      onClick={(e) => {
        if ($(e.target).hasClass('ant-layout-sider-children')) {
          dispatch(setSiderCollapsed(true));
        }
      }}
    >
      <div className={classNames('inline-flex flex-col h-full bg-gray-100 w-[310px]')}>
        <div
          className={classNames(
            'h-16 flex items-center justify-between sticky top-0 z-[9999] bg-gray-100 shadow-sm',
            isMobile ? 'justify-between' : '',
          )}
        >
          <Button
            icon={<MenuOutlined />}
            type="text"
            className="ml-2"
            onClick={() => {
              dispatch(setSiderCollapsed(!siderCollapsed));
            }}
          />
        </div>
        {(true || isPayed) && (
          <div className="flex justify-center items-center py-1 border-0 border-gray-200 border-b border-solid">
            <div className="flex justify-center items-center gap-2 bg-zinc-200 mt-2 mb-1 px-4 py-1.5 rounded-3xl">
              <Button
                className={classNames(
                  tab === 'chats'
                    ? '!bg-white !shadow !text-blue-600'
                    : '!text-gray-500 bg-transparent border-0 shadow-none hover:!bg-white hover:!shadow hover:!text-blue-600',
                )}
                onClick={() => setTab('chats')}
                shape="round"
              >
                Chats
              </Button>
              <Button
                className={classNames(
                  tab === 'analysis'
                    ? '!bg-white !shadow !text-blue-600'
                    : '!text-gray-500 bg-transparent border-0 shadow-none hover:!bg-white hover:!shadow hover:!text-blue-600',
                )}
                onClick={() => {
                  return setTab('analysis');
                }}
                shape="round"
              >
                Analysis
              </Button>
            </div>
          </div>
        )}
        <div className="flex-1 overflow-y-auto">
          {!isPayed && messages.length > 0 && (
            <>
              {tab === 'chats' ? (
                <div className="gap-4 p-6 min-h-96 text-center">
                  <Steps
                    direction="vertical"
                    size="small"
                    current={step}
                    className={classNames(
                      'h-full min-h-96 analysis-steps',
                      `step-${step + 1} percent-${(total % 5) * 20}`,
                    )}
                    items={[
                      {
                        title: (
                          <span className="font-bold" /* ref={ref1} */>
                            Listening ({step === 0 ? parseInt(total % 5) : 5}/5)
                          </span>
                        ),
                      },
                      {
                        title: (
                          <span className="font-bold" /* ref={ref2} */>
                            Analyzing ({step === 1 ? parseInt(total % 5) : step > 1 ? 5 : 0}/5)
                          </span>
                        ),
                      },
                      {
                        title: (
                          <span className="font-bold" /* ref={ref3} */>
                            Roadmap {/* ({step == 2 ? (total % 20) : (step > 2 ? 10 : 0)}/10) */}
                          </span>
                        ),
                      },
                    ]}
                  />
                </div>
              ) : (
                <>
                  {totalMessages <= 200 && (
                    <div className="rounded-2xl bg-white shadow p-4 m-4 text-left">
                      <div className="font-bold text-lg mb-2">Your Progress</div>
                      <div className="w-full h-2 bg-gray-200 rounded mb-2">
                        <div className="h-2 bg-black rounded" style={{ width: `${(totalMessages / 200) * 100}%` }} />
                      </div>
                      <div className="text-gray-600 text-base">
                        {totalMessages} messages • {Math.round((totalMessages / 200) * 100)}% complete
                      </div>
                    </div>
                  )}
                  <Menu
                    onClick={onToolsClick}
                    className="w-full sidebar-menu"
                    openKeys={[openKey]}
                    selectedKeys={[]}
                    mode="inline"
                    items={toolsItems}
                    onOpenChange={() => {}}
                  />
                </>
              )}
            </>
          )}
          {!siderCollapsed &&
            isPayed &&
            (tab === 'chats' ? (
              <>
                <Menu
                  className="w-full sidebar-chat sidebar-menu"
                  openKeys={[selectedThread]}
                  selectedKeys={[selectedThread]}
                  mode="inline"
                  items={items}
                  onSelect={({ key }) => {
                    if (key.includes(selectedThread)) return;
                    dispatch(setPage(1));
                    dispatch(setHasMore(true));
                    dispatch(setMessages([]));
                    dispatch(setSelectedThread(key));
                    navigate(`/playground/${key}`);
                  }}
                  onOpenChange={(openKeys) => {
                    if (openKeys[openKeys.length - 1]) {
                      dispatch(setPage(1));
                      dispatch(setHasMore(true));
                      dispatch(setMessages([]));
                      dispatch(setSelectedThread(openKeys[openKeys.length - 1]));
                      navigate(location.pathname.replace(openKeys[0], openKeys[1]));
                    }
                  }}
                />
                <div className="p-4 h-16 text-center">
                  <Button
                    className="inline-flex items-center"
                    icon={<FaRegEdit />}
                    type="primary"
                    onClick={handleNewChat}
                  >
                    New Chat
                  </Button>
                </div>
              </>
            ) : (
              <>
                {totalMessages <= 200 && (
                  <div className="rounded-2xl bg-white shadow p-4 m-4 text-left">
                    <div className="font-bold text-lg mb-2">Your Progress</div>
                    <div className="w-full h-2 bg-gray-200 rounded mb-2">
                      <div className="h-2 bg-black rounded" style={{ width: `${(totalMessages / 200) * 100}%` }} />
                    </div>
                    <div className="text-gray-600 text-base">
                      {totalMessages} messages • {Math.round((totalMessages / 200) * 100)}% complete
                    </div>
                  </div>
                )}
                <Menu
                  onClick={onToolsClick}
                  className="w-full sidebar-menu"
                  openKeys={[openKey]}
                  selectedKeys={[]}
                  mode="inline"
                  items={toolsItems}
                  onOpenChange={() => {}}
                />
              </>
            ))}
        </div>
        <div className="p-2 border-0 border-gray-300 border-t border-solid h-16">
          <UserMenu />
        </div>
      </div>
      <StepModal
        open={openTour}
        onClose={() => {
          setShowWelcomeAnalysisModal(true);
          setOpenTour(false);
        }}
      />
      <Modal
        centered
        classNames={{ content: '!bg-white' }}
        width={500}
        open={showAnalyzeModal}
        onOk={() => {}}
        onCancel={() => {}}
        footer={[]}
        closable={false}
        maskClosable={false}
      >
        <div className="text-black text-center">
          <Progress
            strokeLinecap="butt"
            percent={40}
            showInfo={false}
            size={['100%', 12]}
            strokeColor="#1b0035"
            trailColor="#e2d0a1"
          />
          <h1 className="my-4 font-extrabold text-black text-center">Your First Analysis!</h1>
          <p className="bg-black my-4 p-3 rounded-md text-[16px] text-gray-100">
            <b>Abby:</b> I did a quick analysis on our conversation so far...
          </p>
          <div className="my-2 md:my-4">
            <Button
              className={classNames('m-1 rounded-none', selectedTab !== 'positive' && 'bg-[#eee]')}
              size=""
              onClick={() => setSelectedTab('positive')}
            >
              Positive Traits
            </Button>
            <Button
              className={classNames('m-1 rounded-none', selectedTab !== 'areas_for_improvement' && 'bg-[#eee]')}
              size=""
              onClick={() => setSelectedTab('areas_for_improvement')}
            >
              Areas of Improvement
            </Button>
          </div>
          <div className="my-2 md:my-4 text-left">
            {analysisData &&
              analysisData[selectedTab].map((data, index) => (
                <div key={index} className="flex items-center">
                  <GoCheckCircleFill
                    className="w-14"
                    fontSize={30}
                    color={selectedTab === 'positive' ? '#27cf27' : '#DB9516'}
                  />
                  <p
                    className="flex-1 my-2 md:my-4"
                    dangerouslySetInnerHTML={{ __html: data.replace('**', '<b>').replace('**', '</b>') }}
                  ></p>
                </div>
              ))}
          </div>
          <Button
            className="px-20 font-bold"
            type="primary"
            size="large"
            onClick={() => {
              setShowAnalyzeModal(false);
            }}
          >
            Keep Chatting
          </Button>
        </div>
      </Modal>
      <RoadmapModal isOpen={showExpiredModal} onClose={() => dispatch(setShowExpiredModal(false))} thread={thread} />
      <UpgradeModal isOpen={showUpgradeModal} onClose={() => dispatch(setShowUpgradeModal(false))} />
      <CreditCardModal
        isOpen={openPayModal}
        onClose={() => dispatch(setOpenPayModal(false))}
        selectedPlan={selectedPlan}
      />
      <WelcomebackModal
        open={showWelcomebackModal}
        onClose={() => {
          handleNewChat();
          setShowWelcomebackModal(false);
        }}
      />
      <SafeModal
        open={showSafeModal}
        onClose={() => {
          setShowSafeModal(false);
          setOpenTour(true);
        }}
      />
      <WordModal
        open={openWordModal}
        onClose={() => {
          dispatch(setOpenWordModal(false));
        }}
      />
      <WelcomeAnalysisModal
        open={showWelcomeAnalysisModal}
        onGotIt={() => {
          setShowWelcomeAnalysisModal(false);
        }}
      />
      <AnalysisModal
        open={showPersonalityModal}
        onClose={() => setShowPersonalityModal(false)}
        title={titles[current]}
        content={user.analysis?.[current]?.content || ''}
      />
      <AnalysisReadyModal
        isOpen={showAnalysisReadyModal}
        onClose={() => setShowAnalysisReadyModal(false)}
        onViewNow={() => {
          setTab('analysis');
          setShowAnalysisReadyModal(false);
          setShowPersonalityModal(true);
          setCurrent(readyKey);
          setReadAnalysis({ type: readyKey });
          dispatch(getUser());
        }}
        type={readyKey}
      />
    </Sider>
  );
}

export default SideBar;
